/*
文件说明：给全局页面添加水印背景；
学习链接：https://blog.csdn.net/qq_38158631/article/details/88058535;
*/

let watermark = {}

let setWatermark = opt => {
  // if (document.querySelector(opt.el))
  let id = "1.23452384164.123412416"

  if (document.getElementById(id) !== null) {
    document.querySelector(opt.el).removeChild(document.getElementById(id))
  }

  //创建一个画布
  let can = document.createElement("canvas")
  //设置画布的长宽
  can.width = 160
  can.height = 160

  let cans = can.getContext("2d")
  //旋转角度
  cans.rotate((opt.rotate * Math.PI) / 180)
  cans.font = opt.font
  //设置填充绘画的颜色、渐变或者模式
  // cans.fillStyle = "#dedede"
  // cans.fillStyle = "rgba(200, 200, 200, 0.90)"
  cans.globalAlpha = 0.15
  //设置文本内容的当前对齐方式
  cans.textAlign = "left"
  //设置在绘制文本时使用的当前文本基线
  cans.textBaseline = "Middle"
  //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  cans.fillText(opt.fillText, -20, 110)

  let div = document.createElement("div")
  div.id = id
  div.style.pointerEvents = "none"
  div.style.top = "74px"
  div.style.left = "0px"
  // div.style.position = "absolute"
  div.style.position = "fixed"
  div.style.zIndex = "100000"
  div.style.width = document.querySelector(opt.el).clientWidth + "px"
  div.style.height = document.querySelector(opt.el).clientHeight + "px"
  div.style.background = "url(" + can.toDataURL("image/png") + ") left top repeat"
  document.querySelector(opt.el).appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = opt => {
  let id = setWatermark(opt)
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(opt)
    }
  }, 500)
  window.onresize = () => {
    setWatermark(opt)
  }
}

export default watermark
